import React from 'react';
import Icon from '../../../components/AppIcon';

const PaymentMethodPerformance = ({ methods }) => {
  const getMethodIcon = (method) => {
    const icons = {
      'VA Transfer': 'Building2',
      'QRIS': 'QrCode',
      'E-Wallet': 'Wallet',
      'Credit Card': 'CreditCard',
      'Debit Card': 'CreditCard'
    };
    return icons?.[method] || 'DollarSign';
  };

  const getSuccessRateColor = (rate) => {
    if (rate >= 95) return 'text-success';
    if (rate >= 85) return 'text-warning';
    return 'text-error';
  };

  const getSuccessRateBg = (rate) => {
    if (rate >= 95) return 'bg-success';
    if (rate >= 85) return 'bg-warning';
    return 'bg-error';
  };

  return (
    <div className="card">
      <div className="mb-6">
        <h3 className="text-lg md:text-xl font-semibold text-foreground mb-1">
          Performa Metode Pembayaran
        </h3>
        <p className="text-sm text-muted-foreground">
          Perbandingan tingkat keberhasilan dan volume transaksi
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {methods?.map((method) => (
          <div
            key={method?.name}
            className="p-4 bg-muted/50 rounded-lg border border-border hover:border-primary/30 hover:shadow-elevation-1 transition-smooth"
          >
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Icon name={getMethodIcon(method?.name)} size={20} className="text-primary" />
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground">{method?.name}</h4>
                  <p className="text-xs text-muted-foreground">{method?.provider}</p>
                </div>
              </div>
            </div>

            <div className="space-y-3">
              <div>
                <div className="flex items-center justify-between mb-1">
                  <span className="text-xs text-muted-foreground">Success Rate</span>
                  <span className={`text-sm font-semibold ${getSuccessRateColor(method?.successRate)}`}>
                    {method?.successRate}%
                  </span>
                </div>
                <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                  <div
                    className={`h-full ${getSuccessRateBg(method?.successRate)} transition-all duration-500`}
                    style={{ width: `${method?.successRate}%` }}
                  />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3 pt-3 border-t border-border">
                <div>
                  <p className="text-xs text-muted-foreground mb-1">Volume</p>
                  <p className="text-sm font-semibold text-foreground data-text">
                    {method?.volume?.toLocaleString('id-ID')}
                  </p>
                </div>
                <div>
                  <p className="text-xs text-muted-foreground mb-1">Revenue</p>
                  <p className="text-sm font-semibold text-foreground data-text">
                    Rp {(method?.revenue / 1000000)?.toFixed(1)}M
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-2 pt-2">
                <Icon 
                  name={method?.trend === 'up' ? 'TrendingUp' : 'TrendingDown'} 
                  size={14} 
                  className={method?.trend === 'up' ? 'text-success' : 'text-error'}
                />
                <span className={`text-xs font-medium ${method?.trend === 'up' ? 'text-success' : 'text-error'}`}>
                  {method?.trendValue}
                </span>
                <span className="text-xs text-muted-foreground">vs minggu lalu</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PaymentMethodPerformance;